export default __webpack_public_path__ + "static/media/ppmcloud_03_t.0be7f588.png";